import formatTimestamp from './timestamp.js'

/**
 * 日期过滤
 * @type Function
 * @param {Date} 时间戳
 */
function date (timestamp, type, format) {
  if (type === 'today') {
    timestamp = Date.now()
  }

  timestamp = formatTimestamp(timestamp)

  if (type === 'timestamp') {
    return timestamp
  }

  if (type === 'near') {
    return near(timestamp, format)
  }

  if (timestamp) {
    let _date = new Date(timestamp)
    let _year = _date.getFullYear()
    let _month = _date.getMonth() + 1 + ''
    let _day = _date.getDate() + ''
    let _hour = _date.getHours() + ''
    let _minute = _date.getMinutes() + ''
    let _second = _date.getSeconds() + ''

    let weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

    _month = _month.length === 2 ? _month : '0' + _month
    _day = _day.length === 2 ? _day : '0' + _day
    _hour = _hour.length === 2 ? _hour : '0' + _hour
    _minute = _minute.length === 2 ? _minute : '0' + _minute
    _second = _second.length === 2 ? _second : '0' + _second

    switch (type) {
      case 'today':
        return new Date(_year, _month - 1, _day, 1, 0, 0)
      case 'prevDay':
        return new Date(_year, _month - 1, --_day)
      case 'nextDay':
        return new Date(_year, _month - 1, ++_day)
      case 'prevWeek':
        return new Date(_year, _month - 1, -7)
      case 'nextWeek':
        return new Date(_year, _month - 1, (_day | 0) + 7)
      case 'year':
        format = 'YYYY 年 MM 月 DD 日'
        break
      case 'date':
        format = 'M 月 D 日 hh-mm'
        break
      case 'datepicker':
        format = 'YYYY-MM-DD hh-mm-ss'
        break
      case 'time':
        format = 'hh-mm-ss'
        break
      default:
        break
    }

    // 默认只传两个参数， format 值为 type
    if (!format) {
      format = type
    }

    format = format.replace('YYYY', _year)
    format = format.replace('MM', _month)
    format = format.replace('M', _month.replace(/^0{1}/gi, ''))
    format = format.replace('DD', _day)
    format = format.replace('D', _day.replace(/^0{1}/gi, ''))

    format = format.replace('hh-mm', 'hh:mm')
    format = format.replace('mm-ss', 'mm:ss')

    format = format.replace('hh', _hour)
    format = format.replace('mm', _minute)
    format = format.replace('ss', _second)

    format = format.replace('W', weekMap[_date.getDay()])

    return format
  }

  return ''
}

function near (timestamp, format = 'YYYY 年 MM 月 DD 日 hh:mm') {
  const minutes = (Date.now() - timestamp) / 1000 / 60 | 0
  const minute = minutes % 60 | 0
  const hour = minutes / 60 | 0
  // const day = hour / 24 | 0

  if (hour === 0) {
    return minute < 10 ? '刚刚' : `${minute} 分钟前`
  } else if (hour < 24) {
    return `${hour} 小时前`
  } else {
    // return day < 8 ? `${day} 天前` : date(timestamp, format)
    return date(timestamp, format)
  }
}

export default date
